import { useEffect } from 'react';

const SetHiddenFieldValue = ({
  setFieldValue,
  fieldToSet,
  valueToSet,
  pkgAddOnQuantity,
  addOnItemId,
  pkgItemId
}) => {
  useEffect(() => {
    new Array(pkgAddOnQuantity).fill('placeholder').forEach((_, idx) => {
      if (idx > 0) {
        setFieldValue(
          `${addOnItemId}-${pkgItemId}-${idx}-${fieldToSet}`,
          valueToSet
        );
      }
    });
  }, [valueToSet]);

  return null;
};

export default SetHiddenFieldValue;
